import React from "react";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import get from "lodash/get";
import {
  BILLING_PERIOD_OPTIONS,
  LICENSE_TYPE_OPTIONS
} from "utils/constants/payment";
import OptionListPicker from "components/OptionListPicker";
import { secondaryBackButton } from "utils/constants/ui";
import MenuNavHeader from "components/MenuNavHeader";

const BillingTypeSettings = () => {
  const { values, setFieldValue } = useFormikContext();

  const goBack = () => {
    setFieldValue(STATE_KEYS.EDITOR.PRICING_INTENT, null);
    setFieldValue(STATE_KEYS.EDITOR.PRICING_ACTIVE_PRICE, null);
  };

  const buttonProps = secondaryBackButton({ onClick: () => goBack() });
  const defaultIntervalProps = {
    label: "Billing",
    value: get(values, STATE_KEYS.MANIFEST.PRICING_DEFAULT_INTERVAL),
    name: STATE_KEYS.MANIFEST.PRICING_DEFAULT_INTERVAL,
    options: BILLING_PERIOD_OPTIONS
  };

  const licenseTypeProps = {
    label: "Pricing",
    value: get(values, STATE_KEYS.MANIFEST.PRICING_LICENSE_TYPE),
    name: STATE_KEYS.MANIFEST.PRICING_LICENSE_TYPE,
    options: LICENSE_TYPE_OPTIONS,
    canUnset: true
  };

  return (
    <div className="w-100">
      <MenuNavHeader navSetters={[buttonProps]} label="Billing presentation" />
      <div className="pt3 bh--inset">
        <div className="f4 ph3 pb3 fw5">Interval</div>
        <div className="f6 lh-copy ph3 pb3">
          Set the default billing interval a customer sees on this page.
        </div>
        <div className="pt3">
          <OptionListPicker {...defaultIntervalProps} />
        </div>
      </div>
      <div className="pt3 bh--inset">
        <div className="f4 ph3 pb3 fw5">Pricing</div>
        <div className="f6 lh-copy ph3 pb3">
          Present pricing for individual or group purchasing.
        </div>
        <div className="pt3">
          <OptionListPicker {...licenseTypeProps} />
        </div>
      </div>
    </div>
  );
};

export default BillingTypeSettings;
